import firebase from 'firebase'; 
 
 
 var firebaseConfig = {
    apiKey: "AIzaSyDSyPA3l3NQphq8Fl8nZ4K_6LGUODRzZKQ",
    authDomain: "remaxperts.firebaseapp.com",
    projectId: "remaxperts",
    storageBucket: "remaxperts.appspot.com",
    messagingSenderId: "501953931972",
    appId: "1:501953931972:web:4bc70accb41beaf9b0b791",
    measurementId: "G-EZYSCZ81GP"
  };
  // Initialize Firebase
  const fire = firebase.initializeApp(firebaseConfig);
//   firebase.analytics();

const auth = fire.auth();
const db = fire.firestore();


  export default fire;